import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
  MenuItem,
  ListSubheader,
} from "@mui/material";

export default function CareGapActionsDialog({
  open,
  onClose,
  onConfirm,
  item,
  workflowStatuses,
}) {
  const [selectedStatus, setSelectedStatus] = React.useState("");
  const [note, setNote] = React.useState("");

  React.useEffect(() => {
    if (!open) {
      setSelectedStatus("");
      setNote("");
    }
  }, [open]);

  const handleConfirm = () => {
    onConfirm?.({ workflowStatusId: selectedStatus, note, item });
    onClose?.();
  };

  // Group statuses by groupName
  const groupedItems = React.useMemo(() => {
    const statuses = Array.isArray(workflowStatuses) ? workflowStatuses : [];
    const groups = {};

    statuses.forEach((ws) => {
      const group = ws.groupName || "Other";
      if (!groups[group]) groups[group] = [];
      groups[group].push(ws);
    });

    const items = [];
    Object.entries(groups).forEach(([groupName, groupStatuses]) => {
      items.push({ type: "header", label: groupName });
      groupStatuses.forEach((ws) => {
        items.push({
          type: "option",
          value: ws.workflowStatusId ?? ws.id,
          label: ws.display ?? ws.code ?? "",
        });
      });
    });

    return items;
  }, [workflowStatuses]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Care Gap Actions – {item?.careGapName}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            select
            label="Workflow Status"
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            fullWidth
          >
            {groupedItems.map((entry, idx) =>
              entry.type === "header" ? (
                <ListSubheader key={`header-${idx}`}>
                  {entry.label}
                </ListSubheader>
              ) : (
                <MenuItem key={entry.value} value={entry.value}>
                  {entry.label}
                </MenuItem>
              )
            )}
          </TextField>

          <TextField
            label="Note"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            multiline
            rows={3}
            fullWidth
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={!selectedStatus}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
